import { h } from 'preact'

export default (props: { type: string, name: string }) =>
  <div class='truncated'>
    <span class='filter-type'>{props.type}: </span>
    <strong>{props.name}</strong>
  </div>
